import { createSelector } from '@reduxjs/toolkit';
import { getMasterDataWithGroupingProducts } from '@yme/pdp-components/ProductCard';
import { ACCESSORIES_ATTR } from './constants';
const getAttributes = createSelector(getMasterDataWithGroupingProducts, (masterData) => masterData?.attributes || []);
export const getAccessories = createSelector(getAttributes, (attributes) => attributes?.find((attribute) => attribute.name === ACCESSORIES_ATTR)?.value || []);
